var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRolarCima01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    transform: "matrix(6.773322e-03 1 -1 6.773322e-03 35.8777 -0.1215)",
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    d: "M19.6,36L19.4,8.1l10,10.1l2.6-2.7L17.5,0.8L3.2,15.6l2.7,2.7l9.9-10.2L15.9,36L19.6,36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRolarCima01);
export default __webpack_public_path__ + "static/media/ico-rolar-cima-01.5cc753974a18c680ec57324fec551040.svg";
export { ForwardRef as ReactComponent };